var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaperPlane(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3,5.7c-.2-.2-.6-.3-.9-.2L4,9.9c-.3.1-.5.4-.6.7,0,.3.1.7.4.8l5.6,3.3,3.3,5.5c.2.3.4.4.7.4s0,0,0,0c.3,0,.6-.3.7-.6l4.4-13.4c0-.3,0-.6-.2-.9ZM13.1,17.7l-2.1-3.5,3.3-3.3c.3-.3.3-.9,0-1.2-.3-.3-.9-.3-1.2,0l-3.3,3.3-3.6-2.1,10.1-3.3-3.3,10.1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperPlane);
export default __webpack_public_path__ + "static/media/paper-plane.799309fafe9329befa5fda28ba0c8251.svg";
export { ForwardRef as ReactComponent };